/* eslint no-shadow: ["error", { "allow": ["state"] }] */

import findIndex from 'lodash/findIndex'
import groupBy from 'lodash/groupBy'
import keyBy from 'lodash/keyBy'
import reject from 'lodash/reject'
import Vue from 'vue'

import { FETCH_CAUSE_FAULTS } from '../../actions.type'
import {
  CREATE_CAUSE_FAULT,
  REMOVE_CAUSE_FAULT,
  SET_CAUSE_FAULT_ALL_REQUEST,
  SET_CAUSE_FAULT_ALL_VALUE,
  UPDATE_CAUSE_FAULT
} from '../../mutations.type'

const state = {
  all: {
    request: {
      isLoading: undefined,
      isSuccess: undefined,
      isError: undefined,
      isFatalError: undefined,
      delay: undefined,
      lastRequestTime: undefined
    },
    value: []
  }
}

const getters = {
  causeFaultAllValue: (state) => state.all.value,
  causeFaultAllRequest: (state) => state.all.request,
  causeFaultAllById: (state) => keyBy(state.all.value, 'id'),
  causeFaultAllByGroupId: (state) =>
    groupBy(state.all.value, 'causeFaultGroup.id')
}

const actions = {
  async [FETCH_CAUSE_FAULTS]({ commit, state }, params) {
    if (
      (state.all.request.isSuccess && !params?.isReload) ||
      state.all.request.isLoading ||
      state.all.request.isError
    ) {
      return
    }
    try {
      const { data } = await Vue.axios.get('cause-fault', {
        'axios-retry': {
          beforeTry: () => {
            commit(SET_CAUSE_FAULT_ALL_REQUEST, {
              isLoading: true,
              isError: false
            })
          },
          afterTry: ({ delay, lastRequestTime }) => {
            commit(SET_CAUSE_FAULT_ALL_REQUEST, {
              isLoading: false,
              isError: true,
              delay,
              lastRequestTime
            })
          }
        }
      })
      commit(SET_CAUSE_FAULT_ALL_REQUEST, {
        isLoading: false,
        isSuccess: true
      })
      commit(SET_CAUSE_FAULT_ALL_VALUE, data)
    } catch (e) {
      commit(SET_CAUSE_FAULT_ALL_REQUEST, {
        isFatalError: true,
        isLoading: false
      })
    }
  },

  async SOCKET_CREATE_CAUSE_FAULT({ commit }, value) {
    commit(CREATE_CAUSE_FAULT, value)
  },

  async SOCKET_UPDATE_CAUSE_FAULT({ commit }, value) {
    commit(UPDATE_CAUSE_FAULT, value)
  },

  async SOCKET_REMOVE_CAUSE_FAULT({ commit }, id) {
    commit(REMOVE_CAUSE_FAULT, id)
  }
}

const mutations = {
  [SET_CAUSE_FAULT_ALL_REQUEST](state, request) {
    state.all.request = {
      ...state.all.request,
      ...request
    }
  },
  [SET_CAUSE_FAULT_ALL_VALUE](state, causeFaults) {
    state.all.value = causeFaults
  },
  [UPDATE_CAUSE_FAULT](state, updatedCauseFault) {
    state.all.value.splice(
      findIndex(state.all.value, { id: updatedCauseFault.id }),
      1,
      updatedCauseFault
    )
  },
  [CREATE_CAUSE_FAULT](state, createdCauseFault) {
    state.all.value.push(createdCauseFault)
  },
  [REMOVE_CAUSE_FAULT](state, id) {
    state.all.value = reject(state.all.value, { id })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
